import { FC } from 'react'
import { getClusterSpiderfyStyle } from 'map-style-utils'
import { FeatureCollection } from 'geojson'
import { Layer, Source, LayerProps } from 'ms-map-gl'
import { CLUSTER_LAYER_ID } from '~map-preview/constants'
import { FeatureIdentifyPlugin } from '../FeatureIdentifyPlugin'
import { getLayerId } from '~map-preview/utils/getLayerId'
import { HoverPlugin } from '../HoverPlugin'

type ClusterSpiderfyComponentProps = {
  pointsGeojson: FeatureCollection
  linesGeojson: FeatureCollection
}

export const ClusterSpiderfyComponent: FC<ClusterSpiderfyComponentProps> = (
  props
) => {
  const { pointsGeojson, linesGeojson } = props
  const { points, lines } = getClusterSpiderfyStyle()
  return (
    <>
      <Source
        id='spiderfied-lines'
        type='geojson'
        data={linesGeojson}
      >
        <Layer
          {...(lines as LayerProps)}
          beforeId={CLUSTER_LAYER_ID}
        />
      </Source>
      <Source
        id='spiderfied-points'
        type='geojson'
        data={pointsGeojson}
        generateId
      >
        <Layer
          {...(points as LayerProps)}
          beforeId={CLUSTER_LAYER_ID}
        />
        <HoverPlugin
          source={'spiderfied-points'}
          layer={getLayerId(points)}
        />
        <FeatureIdentifyPlugin layer={getLayerId(points)} />
      </Source>
    </>
  )
}
